import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTreeModule, MatTreeNestedDataSource } from '@angular/material/tree';
import { TranslocoPipe } from '@jsverse/transloco';
import { TreeStore, expandTree } from 'shared/domain';

import { TaxonomyDto } from '@treetop/shared/model';

import { ButtonDirective } from '../button/button.directive';
import { IconDirective } from '../icon/icon.directive';

@Component({
  selector: 'app-tree-select-dialog',
  standalone: true,
  templateUrl: './tree-select-dialog.component.html',
  styleUrls: ['./tree-select-dialog.component.scss'],
  imports: [TranslocoPipe, MatDialogModule, MatTreeModule, MatIconModule, IconDirective, ButtonDirective],
})
export class TreeSelectDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<TreeSelectDialogComponent>>(MatDialogRef);
  data = inject<TaxonomyDto>(MAT_DIALOG_DATA);
  private treeStore = inject(TreeStore);

  taxonomy = new UntypedFormControl();
  treeControl = new NestedTreeControl<TaxonomyDto>((node) => node.children);
  dataSource = new MatTreeNestedDataSource<TaxonomyDto>();

  ngOnInit(): void {
    this.treeStore.currentTaxonomy$.subscribe((tree) => {
      this.dataSource.data = tree;
      if (this.data?.id) {
        expandTree(this.treeControl, this.dataSource.data, this.data.id);
        this.setActiveNode(this.data);
      }
    });
  }

  hasChild = (_: number, node: TaxonomyDto): boolean => {
    return !!node.children && node.children.length > 0;
  };

  setActiveNode(node: TaxonomyDto): void {
    this.taxonomy.setValue(node);
  }
  saveTaxonomy(): void {
    this.dialogRef.close(this.taxonomy.value);
  }
  closeDialog(): void {
    this.dialogRef.close();
  }
}
